import $ from 'jquery';
import MpModal from '../../../../modules/components/modal.js';
import { applyComponentClickRestrictions, getOptionsFromDataset } from '../../../../util/dom.js';

/** @type {MpModal} */
let instance;

/**
 * @param {HTMLElement} trigger
 * @param {*=} options
 */
export default (trigger, options) => {

	$(trigger).on('click.show-cart-modal', (e) => {

		// Standard component click restrictions
		if (applyComponentClickRestrictions('modal', options, e) === false) {
			return;
		}

		/**
		 * Merge with modal options
		 *
		 * @type {import('../../../../modules/components/modal').MpModalStaticOptions}
		 */
		const modalOptions = {
			url: options.url,
			...getOptionsFromDataset(trigger, 'modal', true),
			relatedTarget: trigger,
		};

		// Display the component
		showCartModal(modalOptions);
	});
};

/**
 * @param {import('../../../../modules/components/modal').MpModalStaticOptions} options
 */
export const showCartModal = (options = {}) => {

	options = {
		url: mpro.config.routes.cart_preview_modal,
		...options,
		disposeOnHide: true,
		navigation: false,
	};

	if (!instance) {
		instance = MpModal.show(options);
	}
	else {
		instance.show({ relatedTarget: options.relatedTarget });
	}

	$(instance.getElement()).one('hide.bs.modal', () => {
		instance = null;
	});

	return instance;
};
